import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './BottomNav.css';
import {clearNavStack} from "../../utils/smartNavigate";

const BottomNav: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const currentPath = location.pathname;

  const tabs = [
    {
      name: t('product.navigation.courses'),
      path: '/courses',
      icon: '/images/ui-svg/home.svg',
      iconSelected: '/images/ui-svg/home_selected.svg',
    },
    {
      name: t('product.navigation.news'),
      path: '/news',
      icon: '/images/ui-svg/megaphone.svg',
      iconSelected: '/images/ui-svg/megaphone-selected.svg',
    },
    {
      name: t('product.navigation.account'),
      path: '/profile',
      icon: '/images/ui-svg/profile.svg',
      iconSelected: '/images/ui-svg/profile_selected.svg',
    },
  ];

  return (
    <nav className="bottom-nav">
      {tabs.map((tab) => {
        const isActive = currentPath === tab.path;
        return (
          <button
            key={tab.name}
            className={`bottom-nav-tab ${isActive ? 'active' : ''}`}
            onClick={() => {
              clearNavStack();
              navigate(tab.path);
            }}
          >
            {isActive && <div className="tab-indicator" />}
            <div className="tab-content">
              <div className={`tab-icon-wrapper ${isActive ? 'active' : ''}`}>
                <img
                  src={isActive ? tab.iconSelected : tab.icon}
                  alt={tab.name}
                  className="tab-icon"
                />
              </div>
              <span className={`tab-label ${isActive ? 'active' : ''}`}>
                {tab.name}
              </span>
            </div>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;
